import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import { useSignal } from "@preact-signals/safe-react";
import { z } from "zod";
import { useGoldData } from "@/utils/use-gold-data";
import { useFilterGold } from "./use-filter-gold";
// import 'tailwindcss/tailwind.css'

// 1.虚拟币，2.汇率，3.黄金
export const listType = z.enum(['coin', 'rate', 'gold'])
type ListType = z.infer<typeof listType>
const A = () => {
  const activeListType = useSignal(1)
  return <div onClick={() => activeListType.value += 2}>{activeListType.value}</div>
}

export default function CenterPage({
  coinListData,
  ctmarketlist,
  collectlist,
}) {

  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [type, setType] = useState(2);
  const [searchTerm, setSearchTerm] = useState("");
  // 检测是否为移动端
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const activeListType = useSignal<ListType>(listType.enum.coin);

  const { filterAction } = useFilterGold(ctmarketlist, activeListType);
  const { data } = useGoldData();

  // 添加窗口大小变化监听
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getFilteredData = (data) => {
    if (!searchTerm) return filterAction(data);

    if (typeof data === "object" && !Array.isArray(data)) {
      const filteredData = {};
      for (const key in data) {
        if (key.toLowerCase().includes(searchTerm.toLowerCase())) {
          filteredData[key] = data[key];
        }
      }
      return filterAction(filteredData);
    } else if (Array.isArray(data)) {
      return filterAction(
        data.filter((item) =>
          item.coinname.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    return filterAction(data);
  };
  
  



  // 渲染移动端版本的USDT节点
  const getMobileUSDTNodes = () => {
    const nodes = [];
    let coinListDataTemp = getFilteredData(coinListData);

    for (const key in coinListDataTemp) {
      const isPriceUp = coinListData[key]?.close >= coinListData[key]?.open;
      const percentChange = coinListData[key]?.close
        ? (
            ((coinListData[key]?.close - coinListData[key]?.open) /
              coinListData[key]?.open) *
            100
          ).toFixed(2)
        : "0.00";

      nodes.push(
        <div
          key={key}
          className="px-2 py-3 border-b border-gray-100 cursor-pointer"
          onClick={() => {
            navigate(`/trade/${key}`);
          }}
        >
          <div className="flex justify-between items-center mb-1">
            <div className="flex items-center">
              <span className="font-bold text-base mr-1">{getName(key)}</span>
              <span className="text-xs text-gray-400">/USDT</span>
            </div>
            <span
              className={`text-base font-medium ${
                isPriceUp ? "text-green-500" : "text-red-500"
              }`}
            >
              {coinListData[key]?.close}
            </span>
            <div
              className={`inline-flex items-center justify-center rounded-sm text-xs ${
                isPriceUp ? "text-white bg-green-500" : "text-white bg-red-500"
              }`}
              style={{
                minWidth: "65px",
                height: "30px",
              }}
            >
              {isPriceUp ? "+" : ""}
              {percentChange}%
            </div>
          </div>
          <div className="flex items-center">
            {/* <div className="text-xs text-gray-400">
              {translate(getText("成交量"))}{" "}
              {(coinListData[key]?.vol || 0).toLocaleString()}
            </div> */}
            {/* <div className="mx-2 text-gray-300">|</div> */}
            <div className="text-xs text-gray-400">
              $ {((coinListData[key]?.close || 0) * 7.1).toFixed(4)}
            </div>
          </div>
        </div>
      );
    }
    return nodes;
  };

  // 渲染移动端版本的自选节点
  const getMobileZXNodes = () => {
    const nodes = [];
    const filteredCollectlist = getFilteredData(collectlist);

    for (const data of filteredCollectlist) {
      const key = data.coinname;
      const isPriceUp = coinListData[key]?.close >= coinListData[key]?.open;
      const percentChange = coinListData[key]?.close
        ? (
            ((coinListData[key]?.close - coinListData[key]?.open) /
              coinListData[key]?.open) *
            100
          ).toFixed(2)
        : "0.00";

      nodes.push(
        <div
          key={key}
          className="px-2 py-3 border-b border-gray-100 cursor-pointer"
          onClick={() => {
            navigate(`/trade/${key}`);
          }}
        >
          <div className="flex justify-between items-center mb-1">
            <div className="flex items-center">
              <span className="font-bold text-base mr-1">
                {key.toUpperCase()}
              </span>
              <span className="text-xs text-gray-400">/USDT</span>
            </div>
            <span
              className={`text-base font-medium ${
                isPriceUp ? "text-green-500" : "text-red-500"
              }`}
            >
              {coinListData[key]?.close}
            </span>
            <div
              className={`flex items-center justify-center rounded-sm px-2 py-1 text-xs text-white ${
                isPriceUp ? "bg-green-500" : "bg-red-500"
              }`}
              style={{ minWidth: "65px", height: "30px" }}
            >
              {isPriceUp ? "+" : ""}
              {percentChange}%
            </div>
          </div>
          <div className="flex items-center">
            {/* <div className="text-xs text-gray-400">
              {translate(getText("成交量"))}{" "}
              {(coinListData[key]?.vol || 0).toLocaleString()}
            </div> */}
            {/* <div className="mx-2 text-gray-300">|</div> */}
            <div className="text-xs text-gray-400">
              $ {((coinListData[key]?.close || 0) * 7.1).toFixed(4)}
            </div>
          </div>
        </div>
      );
    }
    return nodes;
  };

  // 保留原有PC端USDT节点
  const getUSDTNodes = () => {
    const nodes = [];
    let coinListDataTemp = getFilteredData(coinListData);

    for (const key in coinListDataTemp) {
      const isPriceUp = coinListData[key]?.close >= coinListData[key]?.open;
      const percentChange = coinListData[key]?.close
        ? (
            ((coinListData[key]?.close - coinListData[key]?.open) /
              coinListData[key]?.open) *
            100
          ).toFixed(2)
        : "0.00";

      nodes.push(
        <tr
          key={key}
          className="hover:bg-gray-50 cursor-pointer border-b border-gray-100"
          onClick={() => {
            navigate(`/trade/${key}`);
          }}
        >
          <td className="py-3 px-3">
            <div className="flex items-center">
              <div className="w-7 h-7 mr-3 relative rounded-full overflow-hidden bg-gray-50">
                <img
                  src={getLogo(key)}
                  className="w-full h-full object-cover"
                  alt={key}
                />
              </div>
              <div>
                <div className="flex items-center">
                  <span className="font-semibold text-sm">{getName(key)}</span>
                  <span className="ml-1 text-xs text-gray-400">/USDT</span>
                </div>
              </div>
            </div>
          </td>
          <td className="py-3 px-3 text-right">
            <span
              className={`font-medium text-sm ${
                isPriceUp ? "text-green-500" : "text-red-500"
              }`}
            >
              {coinListData[key]?.close}
            </span>
          </td>
          <td className="py-3 px-3 text-right">
            <div
              className={`inline-flex items-center justify-center rounded-sm text-xs ${
                isPriceUp ? "text-white bg-green-500" : "text-white bg-red-500"
              }`}
              style={{
                minWidth: "65px",
                height: "30px",
              }}
            >
              {isPriceUp ? "+" : ""}
              {percentChange}%
            </div>
          </td>
          <td className="py-3 px-3 text-right text-sm text-gray-600">
            {coinListData[key]?.high}
          </td>
          <td className="py-3 px-3 text-right text-sm text-gray-600">
            {coinListData[key]?.low}
          </td>
          <td className="py-3 px-3 text-right text-sm text-gray-600">
            {(coinListData[key]?.vol / 10000).toFixed(2)}
            {translate(getText("萬"))}
          </td>
        </tr>
      );
    }
    return nodes;
  };

  // 保留原有PC端自选节点
  const getZXNodes = () => {
    const nodes = [];
    const filteredCollectlist = getFilteredData(collectlist);

    for (const data of filteredCollectlist) {
      const key = data.coinname;
      const isPriceUp = coinListData[key]?.close >= coinListData[key]?.open;
      const percentChange = coinListData[key]?.close
        ? (
            ((coinListData[key]?.close - coinListData[key]?.open) /
              coinListData[key]?.open) *
            100
          ).toFixed(2)
        : "0.00";

      nodes.push(
        <tr
          key={key}
          className="hover:bg-gray-50 cursor-pointer border-b border-gray-100"
          onClick={() => {
            navigate(`/trade/${key}`);
          }}
        >
          <td className="py-3 px-3">
            <div className="flex items-center">
              <div className="w-7 h-7 mr-3 relative rounded-full overflow-hidden bg-gray-50">
                <img
                  src={getLogo(key)}
                  className="w-full h-full object-cover"
                  alt={key}
                />
              </div>
              <div>
                <div className="flex items-center">
                  <span className="font-semibold text-sm">
                    {key.toUpperCase()}
                  </span>
                  <span className="ml-1 text-xs text-gray-400">/USDT</span>
                </div>
              </div>
            </div>
          </td>
          <td className="py-3 px-3 text-right">
            <span
              className={`font-medium text-sm ${
                isPriceUp ? "text-green-500" : "text-red-500"
              }`}
            >
              {coinListData[key]?.close}
            </span>
          </td>
          <td className="py-3 px-3 text-right">
            <div
              className={`inline-flex items-center justify-center rounded-sm text-xs ${
                isPriceUp ? "text-white bg-green-500" : "text-white bg-red-500"
              }`}
              style={{
                minWidth: "65px",
                height: "30px",
              }}
            >
              {isPriceUp ? "+" : ""}
              {percentChange}%
            </div>
          </td>
          <td className="py-3 px-3 text-right text-sm text-gray-600">
            {coinListData[key]?.high}
          </td>
          <td className="py-3 px-3 text-right text-sm text-gray-600">
            {coinListData[key]?.low}
          </td>
          <td className="py-3 px-3 text-right text-sm text-gray-600">
            {(coinListData[key]?.vol / 10000).toFixed(2)}
            {translate(getText("萬"))}
          </td>
        </tr>
      );
    }
    return nodes;
  };

  const getLogo = (name) => {
    let logo = "";
    for (const ctmarket of ctmarketlist) {
      if (name == ctmarket.coinname) {
        logo = imageConfig.baseImageUrl + ctmarket.logo;
        break;
      }
    }
    return logo;
  };

  const getName = (name) => {
    let name2 = "";
    for (const ctmarket of ctmarketlist) {
      if (name == ctmarket.coinname) {
        name2 =
          ctmarket.type === 2
            ? ctmarket?.issueName
            : ctmarket.coinname.toUpperCase();
        break;
      }
    }
    return name2;
  };

  // Get counters for the UI
  const usdtCount = Object.keys(getFilteredData(coinListData)).length;
  const zxCount = getFilteredData(collectlist).length;

  // 渲染移动端布局
  const RenderMobileLayout = () => {
    return (
      <div className="bg-white">
        <div className="w-full">
          {/* 顶部标题区域 */}
          <div className="bg-white px-4 pt-1 pb-2 shadow-sm sticky top-0 z-20">
            {/* 一级 Tabs（Coin / Rate / Gold） */}
            <div className="flex justify-center gap-4 mb-2 text-sm font-medium text-gray-600">
              {listType.options.map((item) => (
                <div
                  key={item}
                  className={`px-3 py-1 rounded-md cursor-pointer transition ${
                    activeListType.value === item
                      ? "text-white bg-neutral-600 font-semibold"
                      : "text-gray-400 hover:text-gray-600"
                  }`}
                  onClick={() => (activeListType.value = item)}
                >
                  <span className="first-letter:capitalize">{item}</span>
                </div>
              ))}
            </div>
            {/* <div className="w-full h-px bg-neutral-300/20 mb-2"></div> */}

            {/* 二级 Tabs + 搜索 */}
            <div className="flex items-center justify-between border-gray-100 pb-2">
              {/* 二级 Tabs：自选 / USDT */}
              <div className="flex gap-3 text-sm font-medium">
                <button
                  className={`px-2 py-1 rounded ${
                    type === 1 ? "text-gray-800 font-semibold" : "text-gray-400"
                  }`}
                  onClick={() => setType(1)}
                >
                  {translate(getText("自選"))}
                  {zxCount > 0 && (
                    <span className="ml-1 text-xs text-gray-400">
                      ({zxCount})
                    </span>
                  )}
                </button>
                <button
                  className={`px-2 py-1 rounded ${
                    type === 2 ? "text-gray-800 font-semibold" : "text-gray-400"
                  }`}
                  onClick={() => setType(2)}
                >
                  USDT
                  {usdtCount > 0 && (
                    <span className="ml-1 text-xs text-gray-400">
                      ({usdtCount})
                    </span>
                  )}
                </button>
              </div>

              {/* 搜索输入框 */}
              <div className="relative w-36">
                <input
                  type="text"
                  placeholder={translate(getText("搜索幣種"))}
                  className="w-full bg-gray-50 py-1 pl-7 pr-6 text-xs rounded-md border border-gray-200 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {/* 搜索图标 */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 absolute left-2 top-1.5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>

                {/* 清除按钮 */}
                {searchTerm && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 absolute right-2 top-1.5 text-gray-400 cursor-pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    onClick={() => setSearchTerm("")}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>

          {/* 表头 */}
          <div className="flex items-center justify-between px-2 py-1.5 text-xs text-gray-400 bg-gray-50 border-b border-gray-100 sticky top-[50px] z-10">
            {/* <span>{`${translate(getText("幣種"))}/${translate(
              getText("成交量")
            )}`}</span> */}
            <span>{`${translate(getText("幣種"))}`}</span>
            <span>{translate(getText("最新價"))}</span>
            <span>24h{translate(getText("漲跌幅"))}</span>
          </div>

          {/* 内容区域 */}
          <div className="bg-white overflow-auto max-h-[calc(100vh-100px)]">
            {type === 2 && getMobileUSDTNodes()}
            {type === 1 && getMobileZXNodes()}

            {/* 空状态 */}
            {((type === 2 && getMobileUSDTNodes().length === 0) ||
              (type === 1 && getMobileZXNodes().length === 0)) && (
              <div className="flex flex-col items-center justify-center py-10 px-4">
                <div className="text-gray-400 text-sm">
                  {searchTerm
                    ? translate(getText("没有找到匹配的结果"))
                    : type === 1
                    ? translate(getText("暂无自选"))
                    : translate(getText("暂无数据"))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // 渲染PC端布局
  const RenderDesktopLayout = () => {
    return (
      <div className="bg-white rounded-lg shadow-sm max-w-[1200px] mx-auto">
        <div className="w-full">
          {/* 顶部标题区域 */}
          <div className="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-100">
            <div className="flex items-center gap-2">
              {listType.options.map((item) => (
                <div
                  key={item}
                  className={`px-2 text-lg font-medium py-1 rounded-md cursor-pointer ${
                    activeListType.value === item
                      ? "text-neutral-50 bg-neutral-500/20 font-medium"
                      : "text-gray-400"
                  }`}
                  onClick={() => (activeListType.value = item)}
                >
                  <div className="first-letter:capitalize">{item}</div>
                </div>
              ))}
            </div>
            <div className="flex items-center">
              <div className="flex space-x-6">
                <button
                  className={`px-2 py-1 ${
                    type === 1 ? "text-gray-800 font-medium" : "text-gray-400"
                  }`}
                  onClick={() => setType(1)}
                >
                  {translate(getText("自選"))}
                  {zxCount > 0 && (
                    <span className="ml-1 text-xs text-gray-400">
                      ({zxCount})
                    </span>
                  )}
                </button>
                <button
                  className={`px-2 py-1 ${
                    type === 2 ? "text-gray-800 font-medium" : "text-gray-400"
                  }`}
                  onClick={() => setType(2)}
                >
                  USDT
                  {usdtCount > 0 && (
                    <span className="ml-1 text-xs text-gray-400">
                      ({usdtCount})
                    </span>
                  )}
                </button>
              </div>
              <div className="relative w-64">
                <input
                  type="text"
                  placeholder={translate(getText("搜索幣種"))}
                  className="w-full bg-gray-50 py-1.5 px-3 pl-8 rounded text-sm focus:outline-none focus:ring-1 focus:ring-gray-200"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 absolute left-2.5 top-2 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                {searchTerm && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 absolute right-2.5 top-2 text-gray-400 cursor-pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    onClick={() => setSearchTerm("")}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>

          {/* 表格内容 */}
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="bg-gray-50 text-gray-500 text-xs">
                  <th className="py-3 px-3 text-left font-medium tracking-wider">
                    {translate(getText("幣種"))}
                  </th>
                  <th className="py-3 px-3 text-right font-medium tracking-wider">
                    {translate(getText("最新價格"))}
                  </th>
                  <th className="py-3 px-3 text-right font-medium tracking-wider">
                    24h{translate(getText("漲跌幅"))}
                  </th>
                  <th className="py-3 px-3 text-right font-medium tracking-wider">
                    24h{translate(getText("最高"))}
                  </th>
                  <th className="py-3 px-3 text-right font-medium tracking-wider">
                    24h{translate(getText("最低"))}
                  </th>
                  <th className="py-3 px-3 text-right font-medium tracking-wider">
                    24h{translate(getText("成交量"))}
                  </th>
                </tr>
              </thead>
              <tbody>
                {type === 2 && getUSDTNodes()}
                {type === 1 && getZXNodes()}
              </tbody>
            </table>

            {/* 空状态 */}
            {((type === 2 && getUSDTNodes().length === 0) ||
              (type === 1 && getZXNodes().length === 0)) && (
              <div className="flex flex-col items-center justify-center py-10 px-4">
                <div className="text-gray-400 text-sm">
                  {searchTerm
                    ? translate(getText("没有找到匹配的结果"))
                    : type === 1
                    ? translate(getText("暂无自选"))
                    : translate(getText("暂无数据"))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return isMobile ? RenderMobileLayout() : RenderDesktopLayout();
}
